import { Suspense, lazy } from 'react';
import { PageContainer } from '@/components/page-container';
import { Skeleton } from '@/components/skeleton';

// =====================================================================
// AEO audit & tasks — "/app/b/:siteId/visibility/aeo" (WP1 Task 8). Thin
// mount wrapper, same code-splitting precedent as visibility/ai.tsx: keeps
// SiteGetFound's own lazy chunk instead of pulling it into this route
// module eagerly. SiteGetFound now also renders the AEO audit card
// (components/aeo-audit-card.tsx), moved here from the pre-Task-7
// site-detail.tsx — see site-get-found.tsx's file header for the full story.
// =====================================================================

const SiteGetFound = lazy(() =>
  import('@/routes/site-get-found').then((m) => ({ default: m.SiteGetFound })),
);

export function Aeo() {
  return (
    <Suspense
      fallback={
        <PageContainer>
          <Skeleton className="h-24 w-full rounded-xl" />
          <Skeleton className="h-24 w-full rounded-xl" />
          <Skeleton className="h-24 w-full rounded-xl" />
        </PageContainer>
      }
    >
      <SiteGetFound />
    </Suspense>
  );
}
